export default __webpack_public_path__ + "static/life-grid-blue-min-6e1b9bbac6c9939692579cb7d3e79259.png";